/* INDIGREY — make the PDP's promo code word (“Use code INDIGREY10 at
   checkout”) copy on tap, with a toast — zero visual change to the line.
   The word renders as a plain .ig-rd-pdp__promo-word span (the promo line
   is word-split for its reveal animation), so this delegated handler
   recognises the code by its shape (INDIGREY + digits) and copies it.
   Also honours any element that declares data-ig-copy explicitly. */
(function () {
  if (window.__igCouponTapBound) return;
  window.__igCouponTapBound = true;
  function copyCode(code) {
    function fallback() {
      var t = document.createElement('textarea');
      t.value = code;
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (x) {}
      document.body.removeChild(t);
      toast();
    }
    function toast() {
      if (window.IG && window.IG.toast) window.IG.toast('Coupon copied');
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(toast, fallback);
    } else {
      fallback();
    }
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('.ig-rd-pdp__promo-word, [data-ig-copy]') : null;
    if (!el) return;
    var explicit = el.getAttribute('data-ig-copy');
    var text = (el.textContent || '').trim();
    var code = explicit || text;
    /* only the code word itself is tappable — not the rest of the sentence */
    if (!explicit && !/^INDIGREY\d+$/i.test(text)) return;
    copyCode(code.toUpperCase());
  });
})();
